import { toast } from "react-toastify";

import {
  EMAIL_VALIDATION_FAILED,
  EMAIL_VALIDATION_INVALID,
  EMAIL_VALIDATION_MISSING_CREDITS,
  EMAIL_VALIDATION_VALIDATING,
} from "../../constants";

const ZeroBounceSDK = require("@zerobounce/zero-bounce-sdk");

const API_KEY = process.env.REACT_APP_ZEROBOUNCE;
export async function validateEmail(email, ip?): Promise<boolean> {
  const zeroBounce = new ZeroBounceSDK();
  await zeroBounce.init(API_KEY);

  const lastEmail = getLastEmailUsed();
  if (lastEmail.email === email) {
    if (lastEmail.status === "valid") {
      return true;
    } else if (lastEmail.status === "invalid") {
      toast(EMAIL_VALIDATION_INVALID, { type: "error" });
      return false;
    }
  }

  if (!isValidEmail(email)) {
    saveLastEmailUsed(email, "invalid");
    toast(EMAIL_VALIDATION_INVALID, { type: "error" });
    return false;
  }

  try {
    toast(EMAIL_VALIDATION_VALIDATING, { type: "info" });
    const response = await zeroBounce.getCredits();
    if (+response.Credits < 1) {
      toast(EMAIL_VALIDATION_MISSING_CREDITS, { type: "info" });
      return true;
    }
  } catch (error) {
    toast(EMAIL_VALIDATION_FAILED, { type: "info" });
    return false;
  }

  try {
    const response = await zeroBounce.validateEmail(email);

    if (response.status === "invalid") {
      saveLastEmailUsed(email, "invalid");
      toast(EMAIL_VALIDATION_INVALID, { type: "error" });
      return false;
    }
  } catch (error) {
    toast(EMAIL_VALIDATION_FAILED, { type: "info" });
    return false;
  }

  return true;
}

function isValidEmail(email) {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
}

function saveLastEmailUsed(email, status) {
  localStorage.setItem("email", email);
  localStorage.setItem("status", status);
}

function getLastEmailUsed() {
  return {
    email: localStorage.getItem("email"),
    status: localStorage.getItem("status"),
  };
}
